export const truncateText = (text, wordLimit = 20) => {
  if (!text) return "";

  const words = text.split(" ");
  if (words.length <= wordLimit) return text;

  return words.slice(0, wordLimit).join(" ") + "...";
};

export function getFormattedDate() {
  const date = new Date();
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}


export function getFormattedTime() {
  const date = new Date();
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12; // Convert 0 to 12 for AM
  return `${hours}:${minutes} ${ampm}`;
}


export const isCurrentTimeInRange = (startTime, endTime) => {
  if (!startTime || !endTime) return false;  // Guard against null/undefined

  const now = new Date();
  const [startHour, startMinute] = startTime.split(":").map(Number);
  const [endHour, endMinute] = endTime.split(":").map(Number);

  // Convert times to Date objects for easier comparison
  const startDate = new Date(now);
  startDate.setHours(startHour, startMinute, 0, 0);

  // Adjust start time to 30 minutes before the actual start
  const startBuffer = new Date(startDate);
  startBuffer.setMinutes(startBuffer.getMinutes() - 30);

  const endDate = new Date(now);
  endDate.setHours(endHour, endMinute, 0, 0);

  // Check if the current time is within the range
  return now >= startBuffer && now <= endDate;
};



export function getFormattedDate1() {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure two digits
  const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits
  return `${year}-${month}-${day}`;
}

export function formatDateToDDMMYYYY(dateString) {
  if (!dateString) return null;

  const date = new Date(dateString);
  if (isNaN(date)) return null;

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${year}-${month}-${day}`;
}


export function getFormattedDateTable(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
}



export function formatToYYYYMMDD(dateInput) {
  if (!dateInput) return "";

  const date = new Date(dateInput);

  if (isNaN(date.getTime())) return "";

  return date.toISOString().slice(0, 10);
}


// export function formatToAmPm(time24) {
//   if (!time24 || typeof time24 !== "string") return "";

//   const parts = time24.split(":");
//   if (parts.length < 2) return "";

//   const [hourStr, minute] = parts;
//   let hour = parseInt(hourStr, 10);

//   if (isNaN(hour)) return "";

//   const ampm = hour >= 12 ? "PM" : "AM";
//   hour = hour % 12 || 12;

//   return `${hour}:${minute} ${ampm}`;
// }



export function formatToAmPm(time) {
  if (!time) return time;

  // If already contains AM/PM → return as is
  if (/am|pm/i.test(time)) {
    return time;
  }

  const [hourStr, minute] = time.split(":");
  let hour = parseInt(hourStr, 10);

  if (isNaN(hour) || !minute) return time; // fallback safety

  const ampm = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12;

  return `${hour}:${minute} ${ampm}`;
}



export const formatKey = (key) => {
  return key
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};





